import { useState } from "react";
import { addEmployeeDefaults } from "../constants/formDefaults";
import { text as allText } from "../constants/text";

export const useAddEmployeeForm = (language) => {
  const t = allText[language];

  const [formData, setFormData]   = useState(addEmployeeDefaults);
  const [formErrors, setFormErrors] = useState({});

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    // Clear error when user starts typing
    if (formErrors[name]) {
      setFormErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const handleFieldChange = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
    // Clear error when field changes
    if (formErrors[name]) {
      setFormErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const validateForm = () => {
    const errors = {};

    // ──────────────────────────────────────────────
    // Required Basic Information
    // ──────────────────────────────────────────────
    if (!formData.name || !formData.name.trim()) {
      errors.name = t.nameRequired || "Name is required";
    }

    if (!formData.email || !formData.email.trim()) {
      errors.email = t.emailRequired || "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email.trim())) {
      errors.email = t.emailInvalid || "Email is invalid";
    }

    // ──────────────────────────────────────────────
    // Required Work Information
    // ──────────────────────────────────────────────
    if (!formData.department || !formData.department.trim()) {
      errors.department = t.departmentRequired || "Department is required";
    }

    if (!formData.position || !formData.position.trim()) {
      errors.position = t.positionRequired || "Position is required";
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const resetForm = () => {
    setFormData(addEmployeeDefaults);
    setFormErrors({});
  };

  return {
    formData,
    formErrors,
    handleInputChange,
    handleFieldChange,
    validateForm,
    resetForm,
  };
};